// @ts-strict-ignore
import {Component, Injector, OnInit, signal} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Assessment, FetchDataType, SearchFilter, SimUser} from "@models";
import {Translations} from "@translations";
import {FormControl} from "@angular/forms";
import {AutocompleteService} from "../../../../../shared/shared-components/sim-advanced-inputs/autocomplete/autocomplete.service";

export interface DialogData_AssignAssessmentDialogInput extends MatDialogDataBaseInput {
	scenarioRecordingId: string;
	participants: SimUser[];
}

export interface DialogData_AssignAssessmentDialogOutput extends MatDialogDataBaseOutput {
	selectedAssessment: Assessment;
	selectedParticipants: SimUser[];
}

@Component({
	selector: "sim-assign-assessment-dialog",
	templateUrl: "./assign-assessment-dialog.component.html",
	styleUrls: ["./assign-assessment-dialog.component.scss"],
	standalone: false,
})
export class AssignAssessmentDialogComponent
	extends BasicMaterialDialog<
		AssignAssessmentDialogComponent,
		DialogData_AssignAssessmentDialogInput,
		DialogData_AssignAssessmentDialogOutput
	>
	implements OnInit
{
	// Readonly
	readonly FetchDataType = FetchDataType;
	readonly T = Translations;
	// Properties
	assessmentControl = new FormControl<Assessment>(null);
	selectedParticipants: SimUser[] = [];
	participantFilter: SearchFilter;
	selectedUserIds = signal<string[]>([]);

	constructor(_injector: Injector) {
		super(_injector);
	}

	async ngOnInit() {
		super.ngOnInit();
		this.participantFilter = AutocompleteService.getSearchFilter(this.data.participants.map((participant) => participant.id));
	}

	public removeParticipant(user: SimUser): void {
		this.selectedParticipants = this.selectedParticipants.filter((selectedParticipant) => selectedParticipant.id !== user.id);
		this.selectedUserIds.set(this.selectedParticipants.map((participant) => participant.id));
	}

	public addParticipant(user: SimUser): void {
		this.selectedParticipants = [...this.selectedParticipants, user];
		this.selectedUserIds.set(this.selectedParticipants.map((participant) => participant.id));
	}

	public doClose() {
		this.close({
			action: "ok",
			selectedAssessment: this.assessmentControl.value,
			selectedParticipants: this.selectedParticipants,
		});
	}
}
